import { AUTH_PATHS } from '@core/utils/auth-paths'
import { isString } from '@jsfns/core/isString'

const INTERNAL_ORIGIN = 'https://app.invalid'

const AUTH_PAGES = new Set<string>(Object.values(AUTH_PATHS))

function isAuthPage(pathname: string) {
  return AUTH_PAGES.has(
    decodeURIComponent(pathname).replace(/\/+$/, '').toLowerCase()
  )
}

function toInternalDestination(path: string) {
  const url = new URL(path, INTERNAL_ORIGIN)
  const destination = url.pathname + url.search + url.hash
  const leavesApp =
    url.origin !== INTERNAL_ORIGIN || destination.startsWith('//')
  const isHome = destination === '/'

  return leavesApp || isHome || isAuthPage(url.pathname)
    ? undefined
    : destination
}

export function toSafeRedirect(value: unknown): string | undefined {
  if (!isString(value) || !value.startsWith('/')) return undefined

  try {
    return toInternalDestination(value)
  } catch {
    return undefined
  }
}
